// Model data including benchmarks and specifications
export const llmModels = [
  {
    "id": "grok-3.0",
    "name": "Grok 3 [Beta]",
    "provider": "xAI",
    "providerURL": "https://x.ai/",
    "isOpenSource": false,
    "description": "Grok 3 [Beta] is the latest cutting-edge large language model from xAI, engineered for exceptional performance in complex reasoning and mathematical tasks. It leverages real-time knowledge access and advanced multi-modal capabilities to deliver sophisticated solutions across text, code, and mathematical domains. With a substantial 1 million token input context, Grok 3 is designed to handle extensive information for in-depth analysis and generation.",
    "features": [
      "Strong mathematical reasoning",
      "Advanced code generation",
      "Real-time knowledge",
      "Multi-modal capabilities"
    ],
    "specs": [
      { "name": "Input Context", "value": "1M tokens" },
      { "name": "Max Output", "value": "128K tokens" },
      { "name": "Release Date", "value": "December 2024" },
      { "name": "Knowledge Cut-off", "value": "November 17, 2024" }
    ],
    "apiProviders": ["xAI API"],
    "modalities": ["Text", "Code", "Math"],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "84.6%" },
      { "name": "AIME 2024", "score": "93.3%" },
      { "name": "Code SWE", "score": "79.4%" }
    ],
    "inputPrice": "3.00",
    "outputPrice": "15.00"
  },
  {
    "id": "gemini-2.5",
    "name": "Gemini 2.5 Pro",
    "provider": "Google",
    "providerURL": "https://deepmind.google/technologies/gemini/",
    "isOpenSource": false,
    "description": "Gemini 2.5 Pro represents the latest iteration of Google's most capable and versatile large language model. It excels in handling a wide array of tasks involving text, code, and reasoning, further enhanced by its multi-modal understanding and sophisticated tool use capabilities. With access to real-time knowledge and up to 2 million token context window, Gemini 2.5 Pro is built for complex problem-solving and advanced content generation.",
    "features": [
      "Multi-modal understanding",
      "Advanced reasoning",
      "Real-time knowledge",
      "Tool use capabilities"
    ],
    "specs": [
      { "name": "Input Context", "value": "1M tokens (2M soon)" },
      { "name": "Max Output", "value": "65,536 tokens" },
      { "name": "Release Date", "value": "May 6, 2025" },
      { "name": "Knowledge Cut-off", "value": "January 2025" }
    ],
    "apiProviders": ["Google Vertex AI", "Google AI Studio"],
    "modalities": ["Text", "Code", "Vision"],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "84.0%" },
      { "name": "AIME 2024", "score": "92.0%" },
      { "name": "Code SWE", "score": "78.5%" }
    ],
    "inputPrice": "2.50",
    "outputPrice": "12.50"
  },
  {
    "id": "claude-3.7",
    "name": "Claude 3.7",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/news/claude-3-7",
    "isOpenSource": false,
    "description": "Claude 3.7 is Anthropic's flagship model, demonstrating exceptional capabilities in reasoning, analysis, and long context processing. Built upon the principles of Constitutional AI for enhanced safety and reliability, it offers advanced tool use and can process vast amounts of information with its 200K token context window. This model is ideal for complex analytical tasks and sophisticated content creation across text, code, and vision modalities.",
    "features": [
      "Constitutional AI",
      "Advanced reasoning",
      "Tool use capabilities",
      "Long context processing"
    ],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Max Output", "value": "128K tokens (with beta header)" },
      { "name": "Release Date", "value": "February 24, 2025" },
      { "name": "Knowledge Cut-off", "value": "October 2024" }
    ],
    "apiProviders": ["Anthropic API", "Amazon Bedrock", "Google Vertex AI"],
    "modalities": ["Text", "Code", "Vision"],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "86.2%" },
      { "name": "AIME 2024", "score": "94.5%" },
      { "name": "Code SWE", "score": "82.1%" }
    ],
    "inputPrice": "3.00",
    "outputPrice": "15.00"
  },
  {
    "id": "claude-3-sonnet",
    "name": "Claude 3 Sonnet",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/product#claude-3-family",
    "isOpenSource": false,
    "description": "Claude 3 Sonnet, from Anthropic, is a well-balanced large language model meticulously optimized for enterprise workloads. It demonstrates particular strength in Retrieval Augmented Generation (RAG), making it highly effective for knowledge-intensive applications. Sonnet offers a compelling blend of intelligent performance, efficient inference, robust tool utilization, and enterprise-grade reliability, positioning it as a versatile solution for businesses seeking to integrate advanced and safe AI.",
    "features": ["Enterprise Grade", "Retrieval Augmented Generation (RAG)", "Tool Utilization", "Balanced Performance", "Efficient Inference"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Max Output", "value": "4,096 tokens" },
      { "name": "Release Date", "value": "March 2024" },
      { "name": "Knowledge Cut-off", "value": "April 2024" }
    ],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.8%" },
      { "name": "Tool Use", "score": "89.3%" },
      { "name": "Speed t/s", "score": "95.2%" }
    ],
    "inputPrice": "3.00",
    "outputPrice": "15.00"
  },
  {
    "id": "gpt-4.1",
    "name": "GPT-4.1",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "GPT-4.1 is the latest iteration in OpenAI's renowned GPT series, featuring significantly improved reasoning and a suite of specialized capabilities. This model excels at complex text understanding, advanced code generation, and sophisticated mathematical problem-solving. It represents a leap forward in general AI capabilities, suitable for a wide range of demanding applications requiring deep understanding and nuanced generation.",
    "features": ["Advanced Reasoning", "Specialized Capabilities Development", "Code Generation", "Mathematical Problem Solving", "Complex Text Understanding"],
    "specs": [
      { "name": "Input Context", "value": "1M tokens" },
      { "name": "Max Output", "value": "32K tokens" },
      { "name": "Release Date", "value": "April 14, 2025" },
      { "name": "Knowledge Cut-off", "value": "June 2024" }
    ],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "85.9%" },
      { "name": "AIME 2024", "score": "93.8%" },
      { "name": "Code SWE", "score": "83.4%" }
    ],
    "inputPrice": "2.00",
    "outputPrice": "8.00"
  },
  {
    "id": "openai-o4-mini",
    "name": "OpenAI O4 Mini",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "OpenAI O4 Mini is a compact and highly efficient version of the O4 architecture, specifically optimized for rapid inference and streamlined deployment. Despite its smaller size, it retains strong general-purpose reasoning and code generation capabilities, making it an excellent choice for applications requiring speed, efficiency, and lower computational overhead without sacrificing core AI functionalities.",
    "features": ["Rapid Inference", "Compact & Efficient", "Optimized for Deployment", "Code Generation", "General Purpose Reasoning"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Max Output", "value": "100K tokens" },
      { "name": "Release Date", "value": "January 2025" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }
    ],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "96.3%" },
      { "name": "GPQA Diamond", "score": "81.2%" },
      { "name": "Code SWE", "score": "76.5%" }
    ],
    "inputPrice": "0.15",
    "outputPrice": "0.60"
  },
  {
    "id": "yi-34b",
    "name": "Yi 34B",
    "provider": "01.AI",
    "providerURL": "https://01.ai/",
    "isOpenSource": true,
    "description": "Yi 34B, developed by 01.AI, is a powerful open-source large language model delivering strong performance across a spectrum of general tasks and coding applications. It is particularly noted for its efficient inference and bilingual support, primarily in Chinese and English. Being open-source, Yi 34B encourages community collaboration and adaptation for diverse use cases, offering a robust foundation for developers.",
    "features": ["Open Source", "Strong General Task Performance", "Code Generation", "Efficient Inference", "Bilingual (Chinese/English) Support"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Parameters", "value": "34 billion" },
      { "name": "Release Date", "value": "November 2, 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "81.2%" },
      { "name": "Code SWE", "score": "76.5%" },
      { "name": "Speed t/s", "score": "92.1%" }
    ]
  },
  {
    "id": "solar-10.7b",
    "name": "Solar 10.7B",
    "provider": "Upstage",
    "providerURL": "https://upstage.ai/",
    "isOpenSource": true,
    "description": "Solar 10.7B from Upstage is an efficient open-source model that punches above its weight, offering strong performance relative to its compact size. It excels in reasoning and code generation tasks while maintaining fast inference speeds. Its open-source nature and size-efficient performance make it an attractive option for developers looking for a capable yet resource-friendly model.",
    "features": ["Open Source", "Size-Efficient Performance", "Strong Reasoning", "Code Generation", "Fast Inference"],
    "specs": [
      { "name": "Input Context", "value": "4,096 tokens" },
      { "name": "Parameters", "value": "10.7 billion" },
      { "name": "Release Date", "value": "2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "79.8%" },
      { "name": "Code SWE", "score": "72.3%" },
      { "name": "Speed t/s", "score": "94.7%" }
    ]
  },
  {
    "id": "qwen-72b",
    "name": "Qwen 72B",
    "provider": "Alibaba",
    "providerURL": "https://qwenlm.github.io/",
    "isOpenSource": true,
    "description": "Qwen 72B, an open-source initiative by Alibaba, is a large-scale language model particularly distinguished by its strong multilingual capabilities and advanced reasoning. It offers robust performance in code generation and a variety of complex tasks, benefiting from its extensive training. As an open-source model, Qwen 72B is accessible for broad research and development applications, especially those requiring diverse language support.",
    "features": ["Open Source", "Strong Multilingual Capabilities", "Advanced Reasoning", "Code Generation", "Large Scale Model"],
    "specs": [
      { "name": "Input Context", "value": "32,768 tokens" },
      { "name": "Parameters", "value": "72 billion" },
      { "name": "Release Date", "value": "2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.4%" },
      { "name": "AIME 2024", "score": "89.6%" },
      { "name": "Code SWE", "score": "77.9%" }
    ]
  },
  {
    "id": "snowflake-arctic",
    "name": "Snowflake Arctic",
    "provider": "Snowflake",
    "providerURL": "https://www.snowflake.com/blog/arctic-open-and-efficient-foundation-language-models-snowflake/",
    "isOpenSource": false,
    "description": "Snowflake Arctic is a specialized large language model from Snowflake, engineered with a primary focus on data analytics and SQL generation. It is designed to seamlessly integrate within the Snowflake ecosystem, providing enterprise-focused solutions for efficient data tasks, alongside general text generation capabilities. Its specialization makes it a powerful tool for data-driven organizations.",
    "features": ["SQL Generation", "Data Analytics Specialization", "Enterprise Focused", "Efficient for Data Tasks", "Text Generation"],
    "specs": [
      { "name": "Input Context", "value": "4,096 tokens" },
      { "name": "Parameters", "value": "480 billion (17B active)" },
      { "name": "Release Date", "value": "April 2024" }],
    "keyMetrics": [
      { "name": "SQL Gen", "score": "94.2%" },
      { "name": "Data Analysis", "score": "91.8%" },
      { "name": "Speed t/s", "score": "93.5%" }
    ],
    "inputPrice": "0.80",
    "outputPrice": "2.40"
  },
  {
    "id": "phi-2",
    "name": "Phi-2",
    "provider": "Microsoft",
    "providerURL": "https://www.microsoft.com/en-us/research/blog/phi-2-the-surprising-power-of-small-language-models/",
    "isOpenSource": true,
    "description": "Phi-2, developed by Microsoft, is a compact and highly efficient open-source language model designed for a wide range of general tasks. It stands out for its proficiency in code generation and fast response times, making it an excellent choice for applications where resource efficiency and speed are paramount. Its open-source availability promotes wider adoption and innovation.",
    "features": ["Open Source", "Compact & Efficient", "General Task Proficiency", "Code Generation", "Fast Response Times"],
    "specs": [
      { "name": "Input Context", "value": "2,048 tokens" },
      { "name": "Parameters", "value": "2.7 billion" },
      { "name": "Release Date", "value": "December 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "76.5%" },
      { "name": "Code SWE", "score": "71.2%" },
      { "name": "Speed t/s", "score": "95.8%" }
    ]
  },
  {
    "id": "mistral-7b",
    "name": "Mistral 7B",
    "provider": "Mistral AI",
    "providerURL": "https://mistral.ai/news/announcing-mistral-7b/",
    "isOpenSource": true,
    "description": "Mistral 7B, from Mistral AI, is an efficient open-source model celebrated for delivering strong performance despite its relatively small size. It showcases robust reasoning and code generation abilities, further enhanced by its permissive Apache 2.0 license, which encourages broad adoption and commercial use. It's a popular choice for developers seeking a balance of capability and efficiency.",
    "features": ["Open Source", "Efficient Performance (Size-Optimized)", "Strong Reasoning", "Code Generation", "Apache 2.0 License"],
    "specs": [
      { "name": "Input Context", "value": "32,768 tokens" },
      { "name": "Parameters", "value": "7 billion" },
      { "name": "Release Date", "value": "September 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "78.4%" },
      { "name": "Code SWE", "score": "73.6%" },
      { "name": "Speed t/s", "score": "94.9%" }
    ]
  },
  {
    "id": "mixtral-8x7b",
    "name": "Mixtral 8x7B",
    "provider": "Mistral AI",
    "providerURL": "https://mistral.ai/news/mixtral-of-experts/",
    "isOpenSource": true,
    "description": "Mixtral 8x7B is an innovative open-source model from Mistral AI, utilizing a Mixture of Experts (MoE) architecture. This design allows for high performance across diverse tasks by efficiently activating only relevant parts of the model (sparse activation). It excels in code generation and general reasoning, offering top-tier capabilities with the benefits of an open-source license.",
    "features": ["Open Source", "Mixture of Experts (MoE) Architecture", "High Performance Across Tasks", "Code Generation", "Efficient Sparse Activation"],
    "specs": [
      { "name": "Input Context", "value": "32,768 tokens" },
      { "name": "Parameters", "value": "46.7 billion (12.9B active)" },
      { "name": "Release Date", "value": "December 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.2%" },
      { "name": "Code SWE", "score": "79.5%" },
      { "name": "Speed t/s", "score": "91.8%" }
    ]
  },
  {
    "id": "llama-3-70b",
    "name": "Llama 3 70B",
    "provider": "Meta",
    "providerURL": "https://ai.meta.com/blog/meta-llama-3/",
    "isOpenSource": true,
    "description": "Llama 3 70B is the latest large open-source model from Meta, establishing new benchmarks with its state-of-the-art performance and strong general capabilities. It demonstrates advanced reasoning and superior code generation skills, making it a leading choice for developers and researchers seeking cutting-edge open-source AI. Its release signifies a major step in democratizing access to powerful LLMs.",
    "features": ["Open Source", "State-of-the-art Performance", "Strong General Capabilities", "Advanced Reasoning", "Code Generation"],
    "specs": [
      { "name": "Input Context", "value": "8,000 tokens" },
      { "name": "Parameters", "value": "70 billion" },
      { "name": "Release Date", "value": "April 18, 2024" },
      { "name": "Knowledge Cut-off", "value": "December 2023" }
    ],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "84.5%" },
      { "name": "AIME 2024", "score": "92.5%" },
      { "name": "Code SWE", "score": "80.5%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "gemma-7b",
    "name": "Gemma 7B",
    "provider": "Google",
    "providerURL": "https://ai.google.dev/gemma",
    "isOpenSource": true,
    "description": "Gemma 7B is an efficient open-source model developed by Google, leveraging the company's extensive research in AI. It offers strong performance for its size, particularly in reasoning and code generation tasks. Gemma 7B is designed to be accessible and adaptable, providing a solid foundation for a variety of applications that benefit from a capable and open model.",
    "features": ["Open Source", "Efficient Performance", "Strong Reasoning (for size)", "Code Generation Tasks", "Built on Google Research"],
    "specs": [
      { "name": "Input Context", "value": "8,192 tokens" },
      { "name": "Parameters", "value": "7 billion" },
      { "name": "Release Date", "value": "February 21, 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "79.6%" },
      { "name": "Code SWE", "score": "74.8%" },
      { "name": "Speed t/s", "score": "93.9%" }
    ]
  },
  {
    "id": "deepseek-coder",
    "name": "DeepSeek Coder",
    "provider": "DeepSeek",
    "providerURL": "https://www.deepseek.com/en/blog/deepseek-coder",
    "isOpenSource": true,
    "description": "DeepSeek Coder is a specialized open-source model from DeepSeek, purpose-built for excellence in code generation and understanding. It supports multiple programming languages and has achieved high scores on benchmarks like HumanEval, indicating its proficiency in complex coding tasks. This model is an invaluable tool for developers looking to automate or assist in software development.",
    "features": ["Open Source", "Specialized in Code Generation", "Code Understanding", "Supports Multiple Programming Languages", "High HumanEval Score"],
    "specs": [
      { "name": "Input Context", "value": "16,384 tokens" },
      { "name": "Parameters", "value": "33 billion" },
      { "name": "Release Date", "value": "2023" }],
    "keyMetrics": [
      { "name": "Code SWE", "score": "85.2%" },
      { "name": "HumanEval", "score": "82.7%" },
      { "name": "Speed t/s", "score": "92.4%" }
    ]
  },
  {
    "id": "command-r",
    "name": "Command-R",
    "provider": "Cohere",
    "providerURL": "https://cohere.com/command",
    "isOpenSource": false,
    "description": "Command-R is Cohere's latest flagship model, engineered for enterprise-grade applications with a strong emphasis on Retrieval Augmented Generation (RAG) and advanced retrieval capabilities. It supports multilingual inputs and outputs, and excels at tool use, making it highly adaptable for complex business workflows that require accessing and processing proprietary data securely and efficiently.",
    "features": ["Retrieval Augmented Generation (RAG)", "Strong Retrieval Capabilities", "Enterprise Focused", "Multilingual Support", "Tool Use"],
    "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Parameters", "value": "35 billion" },
      { "name": "Release Date", "value": "March 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.7%" },
      { "name": "RAG Score", "score": "88.9%" },
      { "name": "Speed t/s", "score": "93.2%" }
    ],
    "inputPrice": "0.50",
    "outputPrice": "1.50"
  },
  {
    "id": "yi-1534b-chat",
    "name": "Yi 15/34B Chat",
    "provider": "01.AI",
    "providerURL": "https://01.ai/",
    "isOpenSource": true,
    "description": "Yi 15/34B Chat is an advanced open-source chat model from 01.AI, notable for its strong multilingual capabilities and effective instruction following. It is adept at code generation and conversational AI, making it suitable for a wide range of interactive applications. Its open-source nature allows for customization and broad community engagement.",
    "features": ["Open Source", "Advanced Chat Capabilities", "Strong Multilingual Support", "Instruction Following", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Release Date", "value": "November 2023" },
      { "name": "Parameters", "value": "34 billion" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.5%" },
      { "name": "MMLU", "score": "81.2%" },
      { "name": "Code SWE", "score": "77.8%" }
    ]
  },
  {
    "id": "xai-grok-1.5",
    "name": "xAI Grok 1.5",
    "provider": "xAI",
    "providerURL": "https://x.ai/blog/grok-1.5",
    "isOpenSource": false,
    "description": "xAI Grok 1.5 is an improved iteration of the Grok model, featuring enhanced reasoning capabilities and real-time information access. It excels in mathematical problem-solving, code generation, and engaging conversational AI. Grok 1.5 is designed to provide accurate and contextually relevant responses, leveraging its continuous access to up-to-date information.",
    "features": ["Enhanced Reasoning", "Real-time Information Access", "Code Generation", "Mathematical Problem Solving", "Conversational AI"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Release Date", "value": "March 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.1%" },
      { "name": "AIME 2024", "score": "92.4%" },
      { "name": "Code SWE", "score": "78.9%" }
    ],
    "inputPrice": "0.10 / 1M chars",
    "outputPrice": "0.10 / 1M chars"
  },
  {
    "id": "wizardlm-28x22b",
    "name": "WizardLM 28x22B",
    "provider": "WizardLM",
    "providerURL": "https://github.com/nlpxucan/WizardLM",
    "isOpenSource": true,
    "description": "WizardLM 28x22B is a large-scale open-source model renowned for its strong instruction-following capabilities. This model is adept at understanding and executing complex tasks based on user prompts, and also provides robust code generation. Its substantial size contributes to its ability to handle nuanced and multifaceted instructions effectively.",
    "features": ["Open Source", "Strong Instruction Following", "Large Scale Model", "Code Generation", "Complex Task Solving"],
        "specs": [
      { "name": "Release Date", "value": "2024" },
      { "name": "Parameters", "value": "22 billion per expert" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "81.7%" },
      { "name": "Code SWE", "score": "76.9%" },
      { "name": "Speed t/s", "score": "92.3%" }
    ]
  },
  {
    "id": "qwen-257b-a14b-instruct",
    "name": "Qwen 257B A14B Instruct",
    "provider": "Alibaba",
    "providerURL": "https://qwenlm.github.io/",
    "isOpenSource": true,
    "description": "Qwen 257B A14B Instruct is a very large, instruction-tuned open-source model from Alibaba. It boasts an impressive parameter count and demonstrates strong multilingual support alongside proficient code generation. This model is designed to follow complex instructions accurately, making it suitable for advanced research and development in natural language processing.",
    "features": ["Open Source", "Instruction-Tuned", "Strong Multilingual Support", "Large Parameter Count", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "32,768 tokens" },
      { "name": "Release Date", "value": "2024" },
      { "name": "Parameters", "value": "257 billion" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.6%" },
      { "name": "MMLU", "score": "82.9%" },
      { "name": "Code SWE", "score": "79.4%" }
    ]
  },
  {
    "id": "qwen-27b-instruct",
    "name": "Qwen 27B Instruct",
    "provider": "Alibaba",
    "providerURL": "https://qwenlm.github.io/",
    "isOpenSource": true,
    "description": "Qwen 27B Instruct is an efficient, instruction-tuned open-source model from Alibaba, designed for general-purpose tasks. It offers a balance of performance and resourcefulness, with solid code generation capabilities. Being instruction-tuned, it excels at following user directives, making it a versatile tool for various AI applications.",
    "features": ["Open Source", "Instruction-Tuned", "Efficient for General Tasks", "Code Generation", "Balanced Performance"],
        "specs": [
      { "name": "Input Context", "value": "32,768 tokens" },
      { "name": "Release Date", "value": "2024" },
      { "name": "Parameters", "value": "27 billion" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "80.2%" },
      { "name": "Code SWE", "score": "75.8%" },
      { "name": "Speed t/s", "score": "93.6%" }
    ]
  },
  {
    "id": "qwen-3",
    "name": "Qwen 3",
    "provider": "Alibaba",
    "providerURL": "https://qwenlm.github.io/",
    "isOpenSource": false,
    "description": "Qwen 3 is the latest proprietary large language model from Alibaba, showcasing enhanced general capabilities, advanced reasoning, and proficient code generation. This model builds upon the strengths of its predecessors, offering improved performance and broader multilingual support, positioning it as a leading solution for complex AI tasks within Alibaba's ecosystem and beyond.",
    "features": ["Enhanced General Capabilities", "Advanced Reasoning", "Code Generation", "Proprietary Alibaba Model", "Multilingual Support"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Release Date", "value": "2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "84.3%" },
      { "name": "AIME 2024", "score": "91.8%" },
      { "name": "Code SWE", "score": "80.2%" }
    ],
    "inputPrice": "0.40",
    "outputPrice": "1.20"
  },
  {
    "id": "phi-3-medium-128k",
    "name": "Phi-3 Medium 128K",
    "provider": "Microsoft",
    "providerURL": "https://azure.microsoft.com/en-us/blog/introducing-phi-3-redefining-whats-possible-with-small-language-models/",
    "isOpenSource": true,
    "description": "Phi-3 Medium 128K is an open-source model from Microsoft that features an extended context window of 128K tokens, enabling it to process and understand much larger amounts of text. It is designed for strong efficiency and advanced reasoning, and is particularly optimized for on-device deployment, making powerful AI accessible in resource-constrained environments.",
    "features": ["Open Source", "Extended Context Window (128K)", "Strong Efficiency", "Advanced Reasoning", "Optimized for on-device"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Release Date", "value": "May 2024" },
      { "name": "Parameters", "value": "14 billion" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "79.8%" },
      { "name": "Code SWE", "score": "74.6%" },
      { "name": "Speed t/s", "score": "94.2%" }
    ]
  },
  {
    "id": "palm-3",
    "name": "PaLM 3",
    "provider": "Google",
    "providerURL": "https://ai.google/",
    "isOpenSource": false,
    "description": "PaLM 3 is the latest iteration of Google's Pathways Language Model, offering improved reasoning capabilities and enhanced multilingual support. This large language model excels in text generation, code generation, and complex problem-solving, representing Google's continued advancements in creating powerful and versatile AI systems for a global audience.",
    "features": ["Improved Reasoning", "Multilingual Support", "Code Generation", "Text Generation", "Large Language Model from Google"],
        "specs": [],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "85.1%" },
      { "name": "AIME 2024", "score": "92.7%" },
      { "name": "Code SWE", "score": "81.4%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "openai-o3",
    "name": "OpenAI O3",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "OpenAI O3 is an advanced large language model from OpenAI, characterized by its strong general capabilities across a wide range of tasks. It demonstrates powerful reasoning, proficient code generation, excellent mathematical problem-solving skills, and the ability to perform complex text analysis, making it a versatile tool for sophisticated AI applications.",
    "features": ["Advanced General Capabilities", "Strong Reasoning", "Code Generation", "Mathematical Problem Solving", "Complex Text Analysis"],
    "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Max Output", "value": "100,000 tokens" },
      { "name": "Release Date", "value": "December 2024" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "84.8%" },
      { "name": "AIME 2024", "score": "92.9%" },
      { "name": "Code SWE", "score": "81.7%" }
    ],
    "inputPrice": "10.00",
    "outputPrice": "40.00"
  },
  {
    "id": "openai-o1",
    "name": "OpenAI O1",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "OpenAI O1 serves as an efficient base model within OpenAI's portfolio, designed for general task proficiency. It offers reliable code generation, fast inference speeds, and effective text summarization, providing a solid and cost-effective foundation for a variety of AI-driven applications that require a balance of performance and efficiency.",
    "features": ["Efficient Base Model", "General Task Proficiency", "Code Generation", "Fast Inference", "Text Summarization"],
        "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Max Output", "value": "100,000 tokens" },
      { "name": "Release Date", "value": "September 2024" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.3%" },
      { "name": "Code SWE", "score": "77.5%" },
      { "name": "Speed t/s", "score": "93.8%" }
    ],
    "inputPrice": "15.00",
    "outputPrice": "60.00"
  },
  {
    "id": "mistral-small-latest",
    "name": "Mistral Small Latest",
    "provider": "Mistral AI",
    "providerURL": "https://mistral.ai/technology/#models",
    "isOpenSource": false,
    "description": "Mistral Small Latest is a compact and highly efficient model from Mistral AI, optimized for speed and cost-effectiveness. It provides strong performance on general-purpose text tasks and code generation, making it an ideal choice for applications requiring low latency and budget-friendly AI solutions without compromising on core capabilities.",
    "features": ["Optimized for Efficiency", "Fast Inference Speed", "Code Generation", "General Purpose Text Tasks", "Cost-Effective"],
        "specs": [
      { "name": "Input Context", "value": "131,000 tokens" },
      { "name": "Release Date", "value": "March 2025" },
      { "name": "Knowledge Cut-off", "value": "March 2025" },
      { "name": "Parameters", "value": "24 billion" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "79.4%" },
      { "name": "Code SWE", "score": "74.2%" },
      { "name": "Speed t/s", "score": "95.1%" }
    ],
    "inputPrice": "0.10",
    "outputPrice": "0.30"
  },
  {
    "id": "nova-lite",
    "name": "Nova Lite",
    "provider": "Amazon",
    "providerURL": "https://aws.amazon.com/bedrock/",
    "isOpenSource": false,
    "description": "Nova Lite by Anthropic is an efficient model designed for rapid inference and streamlined deployment. It offers a good balance of performance in areas like code generation and general reasoning, while adhering to Anthropic's safety-focused design principles. Nova Lite is suitable for applications needing quick responses and reliable AI behavior.",
    "features": ["Rapid Inference", "Optimized for Deployment", "Efficient Performance", "Code Generation", "Safety-focused Design"],
        "specs": [
      { "name": "Knowledge Cut-off", "value": "Not available" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "81.0%" },
      { "name": "Code SWE", "score": "75.8%" },
      { "name": "Speed t/s", "score": "95.5%" }
    ],
    "inputPrice": "0.06",
    "outputPrice": "0.24"
  },
  {
    "id": "nova-micro",
    "name": "Nova Micro",
    "provider": "Amazon",
    "providerURL": "https://aws.amazon.com/bedrock/",
    "isOpenSource": false,
    "description": "Nova Micro from Anthropic is an ultra-efficient model specifically engineered for edge deployment and applications requiring minimal computational resources. It boasts some of the fastest response times, making it ideal for tasks like code snippet generation or on-device AI where low latency and low power consumption are critical.",
    "features": ["Ultra-Efficient", "Edge Deployment Ready", "Fastest Response Times", "Code Snippet Generation", "Low Computational Cost"],
        "specs": [
      { "name": "Knowledge Cut-off", "value": "Not available" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "79.5%" },
      { "name": "Code SWE", "score": "74.0%" },
      { "name": "Speed t/s", "score": "96.0%" }
    ],
    "inputPrice": "0.035",
    "outputPrice": "0.14"
  },
  {
    "id": "nova-pro",
    "name": "Nova Pro",
    "provider": "Amazon",
    "providerURL": "https://aws.amazon.com/bedrock/",
    "isOpenSource": false,
    "description": "Nova Pro, by Amazon, is a professional-grade model offering a strong balance of performance and capability. It excels in advanced reasoning and code generation tasks, delivering reliable and high-quality output. Nova Pro is designed for demanding applications where sophisticated AI understanding and generation are necessary, leveraging Amazon's infrastructure and AI expertise.",
    "features": ["Professional Grade", "Balanced Performance & Capability", "Advanced Reasoning", "Code Generation", "Reliable Output"],
        "specs": [
      { "name": "Knowledge Cut-off", "value": "Not available" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.9%" },
      { "name": "AIME 2024", "score": "91.6%" },
      { "name": "Code SWE", "score": "79.8%" }
    ],
    "inputPrice": "0.80",
    "outputPrice": "3.20"
  },
  {
    "id": "nova-premier",
    "name": "Nova Premier",
    "provider": "Amazon",
    "providerURL": "https://aws.amazon.com/bedrock/",
    "isOpenSource": false,
    "description": "Nova Premier is Amazon's most capable model for complex tasks, excelling at deep context understanding, multistep planning, and execution across multiple tools and data sources. It features a 1 million token context window and supports text, image, and video inputs.",
    "features": ["Most Capable Nova Model", "Complex Task Specialization", "1M Token Context", "Multimodal Input (Text, Image, Video)", "Advanced Reasoning", "Tool Use"],
    "specs": [
      { "name": "Input Context", "value": "1M tokens" },
      { "name": "Max Output", "value": "4K tokens" },
      { "name": "Release Date", "value": "April 2025" }
    ],
    "apiProviders": ["Amazon Bedrock"],
    "modalities": ["Text", "Image", "Video"],
    "keyMetrics": [
      { "name": "Overall Capability", "score": "Leading" },
      { "name": "Complex Reasoning", "score": "Excellent" },
      { "name": "Multimodal Understanding", "score": "Advanced" }
    ],
    "inputPrice": "1.00",
    "outputPrice": "2.00"
  },
  {
    "id": "mistral-large-latest",
    "name": "Mistral Large Latest",
    "provider": "Mistral AI",
    "providerURL": "https://mistral.ai/technology/#models",
    "isOpenSource": false,
    "description": "Mistral Large Latest is Mistral AI's flagship large model, delivering state-of-the-art performance with strong general capabilities across various domains. It features advanced reasoning, superior code generation, and robust multilingual support, making it a top choice for complex tasks that demand high accuracy and nuanced understanding.",
    "features": ["State-of-the-art Performance", "Strong General Capabilities", "Advanced Reasoning", "Code Generation", "Multilingual Support"],
    "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Release Date", "value": "2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "84.7%" },
      { "name": "AIME 2024", "score": "92.3%" },
      { "name": "Code SWE", "score": "80.9%" }
    ],
    "inputPrice": "4.00",
    "outputPrice": "12.00"
  },
  {
    "id": "luminous-supreme",
    "name": "Luminous Supreme",
    "provider": "Aleph Alpha",
    "providerURL": "https://www.aleph-alpha.com/",
    "isOpenSource": false,
    "description": "Luminous Supreme, from European AI company Aleph Alpha, is an advanced model with strong multilingual capabilities and a focus on explainable AI. It provides robust performance in advanced reasoning and code generation, catering to users who require transparency and understanding of the model's decision-making processes alongside powerful generative features.",
    "features": ["Strong Multilingual Capabilities", "Explainable AI", "European-based Model", "Advanced Reasoning", "Code Generation"],
        "specs": [
      { "name": "Release Date", "value": "2022" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.2%" },
      { "name": "MMLU", "score": "82.1%" },
      { "name": "Code SWE", "score": "78.6%" }
    ],
    "inputPrice": "175.00",
    "outputPrice": "175.00"
  },
  {
    "id": "llama-3.18b",
    "name": "Llama 3 18B",
    "provider": "Meta",
    "providerURL": "https://ai.meta.com/blog/meta-llama-3/",
    "isOpenSource": true,
    "description": "Llama 3 18B is an efficient and powerful open-source model from Meta, offering strong performance particularly notable for its size. It excels in reasoning tasks and code generation, benefiting from strong community support and Meta's advancements in LLM research. This model provides a great balance of capability and accessibility for developers.",
    "features": ["Open Source", "Efficient Performance", "Strong Reasoning (for size)", "Code Generation", "Community Support"],
    "specs": [
      { "name": "Parameters", "value": "18 billion" },
      { "name": "Release Date", "value": "Not released" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "80.4%" },
      { "name": "Code SWE", "score": "75.7%" },
      { "name": "Speed t/s", "score": "93.9%" }
    ]
  },
  {
    "id": "llama-3-405b",
    "name": "Llama 3 405B",
    "provider": "Meta",
    "providerURL": "https://ai.meta.com/blog/meta-llama-3/",
    "isOpenSource": true,
    "description": "Llama 3 405B represents one of the largest open-source models available from Meta, showcasing exceptional capabilities and state-of-the-art reasoning. Its massive parameter scale allows for advanced code generation and deep understanding of complex topics. This model is at the frontier of open-source AI, enabling groundbreaking research and applications.",
    "features": ["Open Source", "Exceptional Capabilities", "State-of-the-art Reasoning", "Advanced Code Generation", "Massive Parameter Scale"],
    "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Parameters", "value": "405 billion" },
      { "name": "Release Date", "value": "July 23, 2024" },
      { "name": "Knowledge Cut-off", "value": "December 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "85.3%" },
      { "name": "AIME 2024", "score": "93.1%" },
      { "name": "Code SWE", "score": "82.4%" }
    ]
  },
  {
    "id": "jurassic-2-ultra",
    "name": "Jurassic-2 Ultra",
    "provider": "AI21 Labs",
    "providerURL": "https://www.ai21.com/blog/introducing-jamba-the-worlds-first-production-grade-mamba-based-model",
    "isOpenSource": false,
    "description": "Jurassic-2 Ultra from AI21 Labs is an advanced proprietary model known for its strong language understanding and contextual awareness. It excels in creative text generation, advanced reasoning, and proficient code generation, making it suitable for applications requiring nuanced and high-quality language outputs. It builds on AI21 Labs' expertise in developing large language models.",
    "features": ["Strong Language Understanding", "Advanced Reasoning", "Creative Text Generation", "Code Generation", "Contextual Awareness"],
    "specs": [
      { "name": "Input Context", "value": "8,192 tokens" },
      { "name": "Release Date", "value": "2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.8%" },
      { "name": "AIME 2024", "score": "91.9%" },
      { "name": "Code SWE", "score": "79.7%" }
    ],
    "inputPrice": "2.00",
    "outputPrice": "10.00"
  },
  {
    "id": "jamba",
    "name": "Jamba",
    "provider": "AI21 Labs",
    "providerURL": "https://www.ai21.com/jamba",
    "isOpenSource": false,
    "description": "Jamba, by AI21 Labs, is an efficient proprietary model optimized for general tasks and streamlined deployment. It provides strong performance for its size in text generation and code-related tasks, offering a balance between capability and resource efficiency. Jamba is designed to be a versatile solution for various enterprise and developer needs.",
    "features": ["Efficient General Task Model", "Deployment Optimized", "Strong Performance for Size", "Text Generation", "Code Tasks"],
    "specs": [
      { "name": "Input Context", "value": "256,000 tokens" },
      { "name": "Parameters", "value": "52 billion (12B active)" },
      { "name": "Release Date", "value": "March 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "81.2%" },
      { "name": "Code SWE", "score": "76.4%" },
      { "name": "Speed t/s", "score": "93.5%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "gpt-4.5",
    "name": "GPT-4.5",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "GPT-4.5 from OpenAI stands as a cutting-edge model with significantly enhanced capabilities over its predecessors. It excels in complex problem-solving, offering enhanced reasoning, advanced code generation, and sophisticated multimodal understanding. This model represents the forefront of AI development, designed for the most demanding and complex tasks.",
    "features": ["Cutting-edge Performance", "Enhanced Reasoning", "Advanced Code Generation", "Multimodal Capabilities", "Complex Problem Solving"],
    "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Max Output", "value": "16,384 tokens" },
      { "name": "Release Date", "value": "Not released" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "86.1%" },
      { "name": "AIME 2024", "score": "94.2%" },
      { "name": "Code SWE", "score": "83.7%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "gpt-4.1-nano",
    "name": "GPT-4.1 nano",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "GPT-4.1 nano is the smallest GPT-4.1 model available. As a result, it's the fastest and cheapest model—though it isn't as powerful as GPT-4.1 or GPT-4.1 mini. It's the model to use for simple tasks, or when you need to prioritize speed and cost-effectiveness.",
    "features": ["Speed Optimized", "Cost-Effective", "Text Generation", "Image Generation"],
    "specs": [
      { "name": "Input Context", "value": "1,047,576 tokens" },
      { "name": "Release Date", "value": "N/A" }
    ],
    "keyMetrics": [
      { "name": "MMLU", "score": "80.1%" },
      { "name": "Global MMLU", "score": "66.9%" },
      { "name": "GPQA Diamond", "score": "50.3%" },
      { "name": "AIME 2024", "score": "29.4%" },
      { "name": "IFEval", "score": "74.5%" },
      { "name": "MMMU", "score": "55.4%" },
      { "name": "MathVista", "score": "56.2%" }
    ],
    "inputPrice": "0.10",
    "outputPrice": "1.40"
  },
  {
    "id": "gpt-3.5-turbo-latest",
    "name": "GPT-3.5 Turbo Latest",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/blog/new-embedding-models-and-api-updates",
    "isOpenSource": false,
    "description": "GPT-3.5 Turbo Latest is the most recent iteration of OpenAI's widely used GPT-3.5 model, offering improved performance, faster response times, and greater cost-effectiveness. It serves as a versatile general-purpose AI assistant, proficient in code generation, text summarization, and conversational AI, making it a popular choice for a broad range of applications.",
    "features": ["Improved Performance (over base 3.5)", "Cost-Effective", "Fast Response Times", "General Purpose AI Assistant", "Code Generation"],
    "specs": [
      { "name": "Input Context", "value": "16,385 tokens" },
      { "name": "Max Output", "value": "4,096 tokens" },
      { "name": "Release Date", "value": "November 2022" },
      { "name": "Knowledge Cut-off", "value": "September 2021" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "80.3%" },
      { "name": "Code SWE", "score": "75.1%" },
      { "name": "Speed t/s", "score": "95.7%" }
    ],
    "inputPrice": "0.50",
    "outputPrice": "1.50"
  },
  {
    "id": "gemma-2b-it",
    "name": "Gemma 2B IT",
    "provider": "Google",
    "providerURL": "https://ai.google.dev/gemma",
    "isOpenSource": true,
    "description": "Gemma 2B IT is an open-source, instruction-tuned model from Google, designed for compact and efficient deployment. It embodies Google's commitment to responsible AI design and is optimized for scenarios where resource efficiency is key. Despite its small size, it provides useful capabilities for various tasks, particularly when fine-tuned.",
    "features": ["Open Source", "Instruction-Tuned", "Compact and Efficient", "Optimized for Deployment", "Responsible AI Design"],
        "specs": [
      { "name": "Input Context", "value": "8,192 tokens" },
      { "name": "Release Date", "value": "February 2024" },
      { "name": "Parameters", "value": "2 billion" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "95.4%" },
      { "name": "GPQA Diamond", "score": "76.8%" },
      { "name": "Code SWE", "score": "71.9%" }
    ]
  },
  {
    "id": "gemini-ultra",
    "name": "Gemini Ultra",
    "provider": "Google",
    "providerURL": "https://deepmind.google/technologies/gemini/#gemini-ultra",
    "isOpenSource": false,
    "description": "Gemini Ultra is Google's most capable and largest model in the Gemini family, demonstrating exceptional performance across a vast spectrum of benchmarks and tasks. It excels in state-of-the-art reasoning, advanced code generation, scientific understanding, and creative content generation, representing a pinnacle of multimodal AI achievement.",
    "features": ["Exceptional Multimodal Performance", "State-of-the-art Reasoning", "Advanced Code Generation", "Scientific Understanding", "Creative Content Generation"],
    "specs": [
      { "name": "Release Date", "value": "February 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "86.4%" },
      { "name": "AIME 2024", "score": "94.7%" },
      { "name": "Code SWE", "score": "84.2%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "gemini-2.0-flash",
    "name": "Gemini 2.0 Flash",
    "provider": "Google",
    "providerURL": "https://deepmind.google/technologies/gemini/",
    "isOpenSource": false,
    "description": "Gemini 2.0 Flash is a high-speed variant within the Gemini family, optimized for rapid inference and latency-sensitive tasks. It offers a cost-efficient solution while retaining strong multimodal capabilities and proficient code generation. This model is ideal for applications requiring quick responses and efficient processing of diverse data types.",
    "features": ["High-Speed Inference", "Optimized for Latency-Sensitive Tasks", "Cost-Efficient", "Multimodal Capabilities", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "1,000,000 tokens" },
      { "name": "Max Output", "value": "8,192 tokens" },
      { "name": "Release Date", "value": "December 2024" },
      { "name": "Knowledge Cut-off", "value": "August 2024" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "96.1%" },
      { "name": "GPQA Diamond", "score": "80.7%" },
      { "name": "Code SWE", "score": "75.8%" }
    ],
    "inputPrice": "0.10",
    "outputPrice": "0.40"
  },
  {
    "id": "gemini-1.5-pro",
    "name": "Gemini 1.5 Pro",
    "provider": "Google",
    "providerURL": "https://deepmind.google/technologies/gemini/#gemini-1.5-pro",
    "isOpenSource": false,
    "description": "Gemini 1.5 Pro is a professional-grade model from Google, offering balanced capabilities with a standout feature of an extremely long context window (up to 2 million tokens). It excels in advanced multimodal reasoning, complex task performance, and sophisticated code generation and understanding, including video analysis. It's designed for professionals and enterprises needing to process and analyze vast amounts of information.",
    "features": ["Long Context Window (up to 2M tokens)", "Advanced Multimodal Reasoning", "Complex Task Performance", "Code Generation and Understanding", "Video Understanding"],
    "specs": [
      { "name": "Input Context", "value": "2,000,000 tokens" },
      { "name": "Max Output", "value": "8,192 tokens" },
      { "name": "Release Date", "value": "February 2024" },
      { "name": "Knowledge Cut-off", "value": "April 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.5%" },
      { "name": "AIME 2024", "score": "91.4%" },
      { "name": "Code SWE", "score": "79.3%" }
    ],
    "inputPrice": "3.50",
    "outputPrice": "10.50"
  },
  {
    "id": "deepseek-r1",
    "name": "DeepSeek R1",
    "provider": "DeepSeek",
    "providerURL": "https://www.deepseek.com/",
    "isOpenSource": true,
    "description": "DeepSeek R1 is an advanced open-source model from DeepSeek AI, distinguished by its strong reasoning abilities and proficiency in mathematical problem-solving. It also possesses solid code generation skills and a broad base of general world knowledge, making it a versatile tool for research and development in various AI domains.",
    "features": ["Open Source", "Strong Reasoning Abilities", "Mathematical Problem Solving", "Code Generation", "General World Knowledge"],
    "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Parameters", "value": "671 billion (37B active)" },
      { "name": "Release Date", "value": "January 2025" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.8%" },
      { "name": "AIME 2024", "score": "90.6%" },
      { "name": "Code SWE", "score": "78.4%" }
    ]
  },
  {
    "id": "deepseek-coder-v2",
    "name": "DeepSeek Coder V2",
    "provider": "DeepSeek",
    "providerURL": "https://www.deepseek.com/en/blog/deepseek-coder-v2",
    "isOpenSource": true,
    "description": "DeepSeek Coder V2 is an improved iteration of DeepSeek's specialized open-source model for code generation. It achieves state-of-the-art results in code generation, an improved HumanEval score, and supports advanced coding tasks with efficient inference. This model is a top choice for developers seeking powerful, open-source, code-centric AI tools.",
    "features": ["Open Source", "State-of-the-art Code Generation", "Improved HumanEval Score", "Supports Advanced Coding Tasks", "Efficient for Code Inference"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Release Date", "value": "May 2024" },
      { "name": "Parameters", "value": "236 billion (21B active)" }],
    "keyMetrics": [
      { "name": "Code SWE", "score": "86.1%" },
      { "name": "HumanEval", "score": "83.9%" },
      { "name": "Speed t/s", "score": "92.8%" }
    ]
  },
  {
    "id": "dbrx-instruct",
    "name": "DBRX Instruct",
    "provider": "Databricks",
    "providerURL": "https://www.databricks.com/blog/introducing-dbrx-new-state-art-open-llm",
    "isOpenSource": false,
    "description": "DBRX Instruct, developed by Databricks, is an instruction-tuned model optimized for enterprise use cases. It leverages a Mixture-of-Experts (MoE) architecture for efficient and strong general performance, including proficient code generation. DBRX Instruct is designed to be a reliable and scalable solution for businesses integrating AI into their workflows.",
    "features": ["Instruction-Tuned", "Enterprise-Optimized", "Mixture-of-Experts Architecture", "Strong General Performance", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "32,768 tokens" },
      { "name": "Release Date", "value": "March 2024" },
      { "name": "Parameters", "value": "132 billion (36B active)" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.9%" },
      { "name": "Code SWE", "score": "78.1%" },
      { "name": "Speed t/s", "score": "93.2%" }
    ],
    "inputPrice": "0.30",
    "outputPrice": "1.30"
  },
  {
    "id": "command-r-plus",
    "name": "Cohere Command R+",
    "provider": "Cohere",
    "providerURL": "https://cohere.com/command",
    "isOpenSource": false,
    "description": "Command-R Plus is an enhanced version of Cohere's Command-R model, offering improved capabilities in Retrieval Augmented Generation (RAG), general performance, and tool use. It is designed for enterprise-grade reliability and supports multilingual applications, making it a powerful choice for businesses needing advanced, production-ready AI solutions.",
    "features": ["Enhanced RAG Capabilities", "Improved General Performance", "Tool Use", "Enterprise Grade Reliability", "Multilingual Support"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Release Date", "value": "April 2024" },
      { "name": "Parameters", "value": "104 billion" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "93.7%" },
      { "name": "GPQA Diamond", "score": "80.5%" },
      { "name": "Code SWE", "score": "76.2%" }
    ],
    "inputPrice": "2.50",
    "outputPrice": "10.00"
  },
  {
    "id": "claude-3-haiku",
    "name": "Claude 3 Haiku",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/product#claude-3-family",
    "isOpenSource": false,
    "description": "Claude 3 Haiku is Anthropic's fastest and most compact model in the Claude 3 family, optimized for near-instantaneous responses. It's highly cost-effective and provides vision capabilities, making it excellent for customer service applications, content moderation, and other tasks requiring rapid, efficient AI assistance while upholding Anthropic's safety standards.",
    "features": ["Fastest Claude Model", "Optimized for Rapid Response", "Cost-Effective", "Vision Capabilities", "Customer Service Applications"],
        "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Max Output", "value": "4,096 tokens" },
      { "name": "Release Date", "value": "March 2024" },
      { "name": "Knowledge Cut-off", "value": "August 2023" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "95.7%" },
      { "name": "GPQA Diamond", "score": "80.1%" },
      { "name": "Code SWE", "score": "75.3%" }
    ],
    "inputPrice": "0.25",
    "outputPrice": "1.25"
  },
  {
    "id": "aws-titan-text-lite",
    "name": "AWS Titan Text Lite",
    "provider": "Amazon",
    "providerURL": "https://aws.amazon.com/bedrock/titan/",
    "isOpenSource": false,
    "description": "AWS Titan Text Lite is an efficient language model from Amazon, specifically optimized for deployment within the AWS ecosystem. It offers scalable and cost-effective solutions for general-purpose language tasks, including text generation and summarization. This model is designed for seamless integration with other AWS services, providing a convenient option for AWS customers.",
    "features": ["Optimized for AWS Ecosystem", "Efficient Text Generation", "Scalable Deployment on AWS", "General Purpose Language Tasks", "Cost-Effective on AWS"],
        "specs": [
      { "name": "Input Context", "value": "4,000 tokens" },
      { "name": "Release Date", "value": "September 2023" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "94.9%" },
      { "name": "GPQA Diamond", "score": "79.7%" },
      { "name": "Code SWE", "score": "74.8%" }
    ],
    "inputPrice": "0.30",
    "outputPrice": "0.40"
  },
  {
    "id": "ai21-jamba-instruct",
    "name": "AI21 Jamba Instruct",
    "provider": "AI21 Labs",
    "providerURL": "https://www.ai21.com/blog/jamba-instruct-details",
    "isOpenSource": false,
    "description": "AI21 Jamba Instruct is an instruction-tuned variant of the Jamba model from AI21 Labs, featuring a novel hybrid architecture combining State Space Models (SSM) and Transformers. This design aims for enhanced task performance, efficient inference, and a long context window, making it a versatile choice for complex instructed tasks.",
    "features": ["Instruction-Tuned", "Hybrid Architecture (SSM-Transformer)", "Enhanced Task Performance", "Long Context Window", "Efficient Inference"],
        "specs": [
      { "name": "Input Context", "value": "256,000 tokens" },
      { "name": "Release Date", "value": "March 2024" },
      { "name": "Parameters", "value": "52 billion (12B active)" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "81.8%" },
      { "name": "Code SWE", "score": "76.9%" },
      { "name": "Speed t/s", "score": "93.1%" }
    ],
    "inputPrice": "0.50",
    "outputPrice": "1.50"
  },
  {
    "id": "openai-o1-mini",
    "name": "OpenAI O1 Mini",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "OpenAI O1 Mini is a compact and efficient version of the O1 model series, optimized for speed and cost-effectiveness. It's well-suited for general text tasks and code snippet generation where resource constraints or latency are primary concerns, offering a lightweight yet capable AI solution from OpenAI.",
    "features": ["Compact & Efficient", "Optimized for Speed", "Cost-Effective", "General Text Tasks", "Code Snippet Generation"],
        "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Max Output", "value": "100,000 tokens" },
      { "name": "Release Date", "value": "September 2024" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "95.2%" },
      { "name": "GPQA Diamond", "score": "78.5%" },
      { "name": "Code SWE", "score": "73.1%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "openai-o1-pro",
    "name": "OpenAI O1 Pro",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "OpenAI O1 Pro is a professional-grade variant within the O1 series, offering enhanced capabilities for more demanding applications. It delivers improved reasoning, advanced code generation, and reliable output for complex task solving, targeting users who need higher performance than the base O1 models.",
    "features": ["Professional Grade Performance", "Enhanced Reasoning", "Advanced Code Generation", "Complex Task Solving", "Reliable Output"],
        "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Max Output", "value": "100,000 tokens" },
      { "name": "Release Date", "value": "December 2024" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.1%" },
      { "name": "AIME 2024", "score": "90.8%" },
      { "name": "Code SWE", "score": "78.9%" }
    ],
    "inputPrice": "150.00",
    "outputPrice": "600.00"
  },
  {
    "id": "openai-o3-mini",
    "name": "OpenAI O3 Mini",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "OpenAI O3 Mini is an efficient variant of the O3 model, designed for rapid deployment and balanced capabilities. It offers fast inference and solid performance in areas like code generation and general text understanding, making it a good choice for applications that require a nimble yet capable model from the OpenAI O3 lineage.",
    "features": ["Rapid Deployment Optimized", "Efficient Performance", "Fast Inference", "Balanced Capabilities", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Max Output", "value": "100,000 tokens" },
      { "name": "Release Date", "value": "January 2025" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "95.6%" },
      { "name": "GPQA Diamond", "score": "80.2%" },
      { "name": "Code SWE", "score": "75.4%" }
    ],
    "inputPrice": "1.10",
    "outputPrice": "4.40"
  },
  {
    "id": "mistral-large-2",
    "name": "Mistral Large 2",
    "provider": "Mistral AI",
    "providerURL": "https://mistral.ai/",
    "isOpenSource": false,
    "description": "Mistral Large 2 is the new generation of Mistral AI's flagship model, significantly more capable in code generation (supports 80+ coding languages), mathematics, and reasoning. It offers strong multilingual support, advanced function calling, a 128K context window, and is designed for cost efficiency, speed, and performance.",
    "features": ["Code generation (80+ languages)", "Mathematics", "Reasoning", "Multilingual support", "Function calling", "Cost efficiency", "Speed", "128K Context Window"],
    "specs": [
      { "name": "Input Context", "value": "128K tokens" },
      { "name": "Max Output", "value": "32K tokens" },
      { "name": "Release Date", "value": "July 24, 2024" }
    ],
    "apiProviders": ["Mistral AI API", "Amazon Bedrock", "IBM watsonx", "Microsoft Azure"],
    "modalities": ["Text", "Code"],
    "keyMetrics": [
      { "name": "MMLU", "score": "84.0%" },
      { "name": "HumanEval (pass@1)", "score": "92%" },
      { "name": "GSM8K (maj@8, 8-shot)", "score": "93%" }
    ],
    "inputPrice": "3.00",
    "outputPrice": "9.00"
  },
  {
    "id": "mistral-large",
    "name": "Mistral Large",
    "provider": "Mistral AI",
    "providerURL": "https://mistral.ai/technology/#models",
    "isOpenSource": false,
    "description": "Mistral Large is the original large foundational model from Mistral AI, known for its strong performance in advanced reasoning and code generation. It offers robust multilingual capabilities and is designed for high-throughput inference, making it a powerful and versatile tool for a wide array of AI applications requiring sophisticated language processing.",
    "features": ["Strong Foundational Performance", "Advanced Reasoning", "Code Generation", "Multilingual Capabilities", "High-Throughput Inference"],
        "specs": [
      { "name": "Input Context", "value": "32,000 tokens" },
      { "name": "Release Date", "value": "February 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "83.7%" },
      { "name": "AIME 2024", "score": "91.2%" },
      { "name": "Code SWE", "score": "79.8%" }
    ],
    "inputPrice": "2.00",
    "outputPrice": "6.00"
  },
  {
    "id": "llama-3.370b",
    "name": "Llama 3 370B",
    "provider": "Meta",
    "providerURL": "https://ai.meta.com/blog/meta-llama-3/",
    "isOpenSource": true,
    "description": "Llama 3 370B is a massive open-source model from Meta, offering exceptional scale and performance. It features state-of-the-art reasoning, advanced code generation capabilities, and deep domain knowledge due to its extensive training. This model pushes the boundaries of open-source AI, enabling sophisticated research and large-scale applications.",
    "features": ["Open Source", "Exceptional Scale & Performance", "State-of-the-art Reasoning", "Advanced Code Generation", "Deep Domain Knowledge"],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "85.8%" },
      { "name": "AIME 2024", "score": "93.4%" },
      { "name": "Code SWE", "score": "82.9%" }
    ]
  },
  {
    "id": "gpt-4o",
    "name": "GPT-4 Optimized",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/index/hello-gpt-4o/",
    "isOpenSource": false,
    "description": "GPT-4 Optimized (GPT-4o) is OpenAI's groundbreaking omni-modal model, natively handling text, audio, and vision inputs and outputs. It offers significantly enhanced efficiency and faster response times compared to previous GPT-4 versions, while maintaining advanced reasoning and code generation capabilities. GPT-4o sets a new standard for interactive and multimodal AI experiences.",
    "features": ["Omni-modal (Text, Audio, Vision)", "Enhanced Efficiency over GPT-4", "Faster Response Times", "Advanced Reasoning", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Max Output", "value": "4,096 tokens" },
      { "name": "Release Date", "value": "May 2024" },
      { "name": "Knowledge Cut-off", "value": "April 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "85.4%" },
      { "name": "AIME 2024", "score": "93.1%" },
      { "name": "Code SWE", "score": "82.6%" }
    ],
    "inputPrice": "2.50",
    "outputPrice": "10.00"
  },
  {
    "id": "gemini-1.5-flash",
    "name": "Gemini 1.5 Flash",
    "provider": "Google",
    "providerURL": "https://ai.google.dev/gemini-api/docs/models#gemini-1.5-flash",
    "isOpenSource": false,
    "description": "Gemini 1.5 Flash is a fast and versatile multimodal model by Google, optimized for scaling across diverse tasks. It supports text, image, audio, and video inputs.",
    "features": ["Multimodal Input (Text, Image, Audio, Video)", "1M Token Context Window", "Optimized for Speed & Efficiency", "Versatile Task Performance"],
    "specs": [
      { "name": "Input Context", "value": "1M tokens" },
      { "name": "Output Token Limit", "value": "8,192 tokens" },
      { "name": "Release Date (Latest Update)", "value": "September 2024" }
    ],
    "apiProviders": ["Google AI Studio", "Vertex AI"],
    "pricing": {
      "inputPrice": "0.075 per 1M tokens (<=128K tokens)",
      "outputPrice": "0.30 per 1M tokens (<=128K tokens)",
      "inputPriceLongContext": "$0.0000375 / 1k characters (>128K tokens)",
      "outputPriceLongContext": "$0.00015 / 1k characters (>128K tokens)"
    },
    "trainingDataCutoff": "May 2024", // Assuming based on general Gemini 1.5 info, specific cutoff for Flash not prominent in search results.
    "inputPrice": "0.075",
    "outputPrice": "0.30"
  },
  {
    "id": "claude-3.7-sonnet-base",
    "name": "Claude 3.7 Sonnet Base",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/news/claude-3-7",
    "isOpenSource": false,
    "description": "Claude 3.7 Sonnet Base serves as the foundational model for Anthropic's Claude 3.7 Sonnet series. It offers balanced performance, robust tool utilization, and efficient inference, all while incorporating Anthropic's signature safety features. This model provides a reliable and capable starting point for developing applications with the Sonnet architecture.",
    "features": ["Foundation for Claude 3.7 Sonnet", "Balanced Performance", "Tool Utilization", "Efficient Inference", "Safety Features (Anthropic)"],
        "specs": [
      { "name": "Input Context", "value": "200,000 tokens" },
      { "name": "Max Output", "value": "8,192 tokens" },
      { "name": "Release Date", "value": "February 2025" },
      { "name": "Knowledge Cut-off", "value": "October 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.4%" },
      { "name": "Tool Use", "score": "88.7%" },
      { "name": "Speed t/s", "score": "94.8%" }
    ],
    "inputPrice": "3.00",
    "outputPrice": "15.00"
  },
  {
    "id": "grok-1.5v",
    "name": "Grok 1.5v",
    "provider": "xAI",
    "providerURL": "https://x.ai/blog/grok-1.5v",
    "isOpenSource": false,
    "description": "Grok 1.5v is a vision-enabled variant of xAI's Grok 1.5 model, introducing multimodal capabilities to the Grok family. It combines enhanced reasoning and real-time information access with the ability to understand and process visual inputs, alongside its existing strengths in code generation and text-based tasks.",
    "features": ["Vision Capabilities", "Multimodal Understanding", "Real-time Information Access", "Enhanced Reasoning", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Release Date", "value": "April 2024" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "82.8%" },
      { "name": "Vision Tasks", "score": "89.4%" },
      { "name": "Code SWE", "score": "77.9%" }
    ],
    "inputPrice": "5.00",
    "outputPrice": "15.00"
  },
  {
    "id": "llama-3-1405b",
    "name": "Llama 3 1405B",
    "provider": "Meta",
    "providerURL": "https://ai.meta.com/blog/meta-llama-3/",
    "isOpenSource": true,
    "description": "Llama 3 1405B is reportedly the largest and most capable model in Meta's Llama 3 family, offering unprecedented scale and frontier performance for an open-source model. It is expected to deliver state-of-the-art reasoning and advanced multitask capabilities, pushing the boundaries of what is achievable with openly available AI.",
    "features": ["Open Source", "Unprecedented Scale", "Frontier Performance", "State-of-the-art Reasoning", "Advanced Multitask Capabilities"],
        "specs": [
      { "name": "Parameters", "value": "1405 billion" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "86.2%" },
      { "name": "AIME 2024", "score": "94.1%" },
      { "name": "Code SWE", "score": "83.5%" }
    ]
  },
  {
    "id": "llama-3-170b-instruct",
    "name": "Llama 3 170B Instruct",
    "provider": "Meta",
    "providerURL": "https://ai.meta.com/blog/meta-llama-3/",
    "isOpenSource": true,
    "description": "Llama 3 170B Instruct is an instruction-tuned variant of Meta's Llama 3 170B model. This open-source model is optimized to follow user instructions with high fidelity, offering strong performance for its scale in advanced reasoning and code generation. It provides a powerful and adaptable foundation for building sophisticated instructed AI applications.",
    "features": ["Open Source", "Instruction-Tuned", "Strong Performance for 170B Scale", "Advanced Reasoning", "Code Generation"],
        "specs": [
      { "name": "Parameters", "value": "170 billion" }],
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "84.9%" },
      { "name": "AIME 2024", "score": "92.8%" },
      { "name": "Code SWE", "score": "81.2%" }
    ]
  },
  {
    "id": "gpt-4o-mini",
    "name": "GPT-4O Mini",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/index/hello-gpt-4o/",
    "isOpenSource": false,
    "description": "GPT-4O Mini is a compact and efficient variant of OpenAI's flagship GPT-4 Optimized (GPT-4o) model. It brings omni-modal capabilities (text, audio, vision) to a smaller footprint, optimized for speed, cost, and deployment in resource-sensitive environments. While scaled down, it aims to provide a balance of GPT-4o's advanced features with greater accessibility and efficiency.",
    "features": ["Omni-modal Capabilities (scaled down)", "Compact & Efficient", "Optimized for Speed & Cost", "Balanced performance/size", "Code Generation"],
        "specs": [
      { "name": "Input Context", "value": "128,000 tokens" },
      { "name": "Max Output", "value": "16,384 tokens" },
      { "name": "Release Date", "value": "July 2024" },
      { "name": "Knowledge Cut-off", "value": "October 2023" }],
    "keyMetrics": [
      { "name": "Speed t/s", "score": "95.7%" },
      { "name": "GPQA Diamond", "score": "80.1%" },
      { "name": "Code SWE", "score": "75.3%" }
    ],
    "inputPrice": "0.15",
    "outputPrice": "0.60"
  },
  {
    "id": "palm-2-text-bison-32k",
    "name": "PaLM 2 Text Bison 32K",
    "provider": "Google",
    "providerURL": "https://cloud.google.com/vertex-ai/generative-ai/docs/deprecations/palm",
    "isOpenSource": false,
    "description": "PaLM 2 Text Bison 32K is a Google foundation model from the PaLM 2 family, optimized for text generation and understanding with an extended 32,768 token context window. It excels at tasks like classification, summarization, extraction, and long-form content creation, available via Google Cloud Vertex AI.",
    "features": ["Text generation", "Classification", "Summarization", "Extraction", "Content creation", "Long context (32K tokens)"],
    "specs": [
      { "name": "Input Context", "value": "32768 tokens" },
      { "name": "Max Output", "value": "8192 tokens" },
      { "name": "Release Date", "value": "May 2023 (PaLM 2 general)" }
    ],
    "apiProviders": ["Google Vertex AI"],
    "modalities": ["Text"],
    "inputPrice": "4.00",
    "outputPrice": "4.00"
  },
  {
    "id": "bloom",
    "name": "BLOOM",
    "provider": "BigScience",
    "providerURL": "https://huggingface.co/bigscience/bloom",
    "isOpenSource": true,
    "description": "BLOOM (BigScience Large Open-science Open-access Multilingual Language Model) is a 176 billion parameter open-access multilingual language model. It is able to generate text in 46 natural languages and 13 programming languages. It was created by a large international collaboration of researchers and engineers.",
    "features": ["Open-access", "Multilingual (46 natural languages)", "Supports 13 programming languages", "Large scale (176B parameters)", "Community-driven"],
    "specs": [
      { "name": "Parameters", "value": "176 billion" },
      { "name": "Training Data Tokens", "value": "~366 billion (1.6TB)" },
      { "name": "Release Date", "value": "July 2022" }
    ],
    "apiProviders": ["Hugging Face"],
    "modalities": ["Text"],
    "keyMetrics": [
      { "name": "MMLU (5-shot)", "score": "26.2%" },
      { "name": "HumanEval (pass@1)", "score": "11.2%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "jamba-1.5-large",
    "name": "Jamba 1.5 Large",
    "provider": "AI21 Labs",
    "providerURL": "https://www.ai21.com/jamba",
    "isOpenSource": true,
    "description": "Jamba 1.5 Large is part of AI21 Labs\' Jamba family of open models, designed for enterprise use with a focus on long-context AI (up to 256K tokens), speed, quality, and multilingual capabilities (9 languages). It offers JSON output support and is available under the Jamba Open Model License.",
    "features": ["Open model", "Long context (256K tokens)", "High speed & efficiency", "Multilingual (9 languages)", "JSON output support", "Enterprise-focused"],
    "specs": [
      { "name": "Input Context", "value": "256K tokens" },
      { "name": "Release Date", "value": "August 2024" }
    ],
    "apiProviders": ["Amazon Bedrock", "Azure AI", "Hugging Face"],
    "modalities": ["Text"],
    "keyMetrics": [],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "llama-3.3-70b-instruct",
    "name": "Llama 3.3 70B Instruct",
    "provider": "Meta",
    "providerURL": "https://huggingface.co/meta-llama/Llama-3.3-70B-Instruct",
    "isOpenSource": true,
    "description": "Llama 3.3 70B Instruct is Meta AI's large language model offering performance comparable to much larger models with significantly reduced hardware requirements. It excels in instruction following, multilingual tasks, and coding, with an extended 128K token context length. Optimized for cost-effective inference.",
    "features": ["Open source", "70B parameters", "Instruction-tuned", "Multilingual", "Coding", "128K context length", "Cost-effective inference"],
    "specs": [
      { "name": "Parameters", "value": "70 billion" },
      { "name": "Input Context", "value": "128K tokens" },
      { "name": "Release Date", "value": "Q3-Q4 2024 (approx.)" }
    ],
    "apiProviders": ["Hugging Face", "Various cloud providers"],
    "modalities": ["Text"],
    "keyMetrics": [
      { "name": "MMLU (5-shot)", "score": "83.0%" },
      { "name": "GPQA (0-shot)", "score": "39.1%" },
      { "name": "HumanEval (pass@1)", "score": "83.3%" },
      { "name": "GSM8K (maj@8)", "score": "94.2%" },
      { "name": "MATH (4-shot, CoT)", "score": "50.4%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "cohere-aya-latest",
    "name": "Cohere AYA Latest",
    "provider": "Cohere",
    "providerURL": "https://cohere.com/aya-latest",
    "isOpenSource": false,
    "description": "Cohere AYA Latest is a cutting-edge language model developed by Cohere, designed for advanced natural language processing tasks. It excels in understanding and generating text in multiple languages, making it a versatile tool for multilingual applications. Cohere AYA Latest is optimized for high-performance inference and is suitable for a wide range of use cases.",
    "features": ["Multilingual Language Model", "Advanced NLP Capabilities", "High-Performance Inference", "Versatile Use Cases"],
        "specs": [
      { "name": "Input Context", "value": "16,000 tokens" },
      { "name": "Release Date", "value": "February 2024" },
      { "name": "Parameters", "value": "35 billion" }],
    "keyMetrics": [
      { "name": "Multilingual Performance", "score": "90.0%" },
      { "name": "Cross-lingual Transfer", "score": "85.0%" },
      { "name": "Low-resource Language Support", "score": "80.0%" }
    ],
    "inputPrice": "0.50",
    "outputPrice": "1.50"
  },
  {
    "id": "llama-3-8b-instruct",
    "name": "Llama 3 8B Instruct",
    "provider": "Meta",
    "providerURL": "https://ai.meta.com/blog/meta-llama-3/",
    "isOpenSource": true,
    "description": "Llama 3 8B Instruct is an instruction-tuned version of Meta's Llama 3 8B model, optimized for dialogue use cases. It offers a strong balance of performance and efficiency for an 8 billion parameter model, with improved reasoning and instruction following capabilities compared to Llama 2.",
    "features": ["Open Source", "Instruction-Tuned", "Efficient Performance", "Improved Reasoning", "Dialogue Optimization"],
    "specs": [
      { "name": "Input Context", "value": "8K tokens" },
      { "name": "Parameters", "value": "8B" },
      { "name": "Release Date", "value": "April 2024" }
    ],
    "apiProviders": ["Hugging Face", "Various cloud providers"],
    "modalities": ["Text", "Code"],
    "keyMetrics": [
      { "name": "MMLU (5-shot)", "score": "68.4%" },
      { "name": "HumanEval (0-shot)", "score": "62.2%" },
      { "name": "GSM-8K (8-shot, CoT)", "score": "79.6%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "phi-3-mini-4k-instruct",
    "name": "Phi-3 Mini 4K Instruct",
    "provider": "Microsoft",
    "providerURL": "https://azure.microsoft.com/en-us/blog/introducing-phi-3-redefining-whats-possible-with-slms/",
    "isOpenSource": true,
    "description": "Phi-3 Mini 4K Instruct is a 3.8B parameter, lightweight, state-of-the-art open model. It is instruction-tuned and supports a 4K context length, excelling in reasoning, coding, and math benchmarks for its size.",
    "features": ["Open Source", "Lightweight", "Instruction-Tuned", "Strong Reasoning", "Code Generation", "4K Context"],
    "specs": [
      { "name": "Input Context", "value": "4K tokens" },
      { "name": "Parameters", "value": "3.8B" },
      { "name": "Release Date", "value": "June 2024" }
    ],
    "apiProviders": ["Hugging Face", "Azure AI Studio", "Ollama"],
    "modalities": ["Text", "Code"],
    "keyMetrics": [
      { "name": "MMLU (5-shot)", "score": "70.9%" },
      { "name": "GSM8K CoT (8-shot)", "score": "85.7%" },
      { "name": "HumanEval (0-shot)", "score": "57.3%" }
    ],
    "inputPrice": "N/A",
    "outputPrice": "N/A"
  },
  {
    "id": "claude-3-opus",
    "name": "Claude 3 Opus",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/news/claude-3-family",
    "isOpenSource": false,
    "description": "Claude 3 Opus is Anthropic's most intelligent model, excelling at complex analysis, and longer tasks like research and development. It offers top-level performance, fluency, and human-like understanding. It can process a wide range of visual formats, including photos, charts, graphs and technical diagrams.",
    "features": ["Vision Capabilities", "Advanced Reasoning", "Complex Task Automation", "Research & Development", "Strategy Analysis"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Release Date", "value": "March 2024" },
      { "name": "Max Output", "value": "4096 tokens" }
    ],
    "apiProviders": ["Anthropic API", "Amazon Bedrock", "Google Cloud Vertex AI"],
    "pricing": {
      "inputPrice": "15 per 1M tokens",
      "outputPrice": "75 per 1M tokens"
    },
    "keyMetrics": [
      { "name": "MMLU", "score": "86.8%" },
      { "name": "MT-Bench", "score": "9.45" },
      { "name": "HumanEval", "score": "84.9%" },
      { "name": "GPQA Diamond", "score": "50.4%" }
    ],
    "trainingDataCutoff": "August 2023",
    "inputPrice": "15",
    "outputPrice": "75"
  },
  {
    "id": "gpt-4-turbo",
    "name": "GPT-4 Turbo",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/blog/new-models-and-developer-products-announced-at-devday",
    "isOpenSource": false,
    "description": "GPT-4 Turbo is a large multimodal model by OpenAI that can accept image and text inputs and output text. It has a 128k context window and knowledge up to April 2023. It is optimized for performance and offered at a lower price compared to GPT-4.",
    "features": ["Multimodal Input (Text & Image)", "128K Context Window", "Optimized Performance", "Knowledge up to April 2023", "Lower Price than GPT-4"],
    "specs": [
      { "name": "Input Context", "value": "128K tokens" },
      { "name": "Knowledge Cutoff", "value": "April 2023" },
      { "name": "Release Date", "value": "November 2023" }
    ],
    "apiProviders": ["OpenAI API", "Microsoft Azure"],
    "pricing": {
      "inputPrice": "10",
      "outputPrice": "30"
    },
    "keyMetrics": [
      { "name": "GPQA Diamond", "score": "86.4%" },
      { "name": "MT-Bench", "score": "8.99" },
      { "name": "HumanEval", "score": "87.2%" },
      { "name": "MMLU", "score": "86.4%" }
    ],
    "trainingDataCutoff": "April 2023",
    "inputPrice": "10",
    "outputPrice": "30"
  },
  {
    "id": "claude-3.5-sonnet",
    "name": "Claude 3.5 Sonnet",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/news/claude-3-5-sonnet",
    "isOpenSource": false,
    "description": "Claude 3.5 Sonnet is Anthropic's first release in the Claude 3.5 model family. It raises the industry bar for intelligence, outperforming competitor models and Claude 3 Opus on a wide range of evaluations, with the speed and cost of their mid-tier model, Claude 3 Sonnet. It shows marked improvement in grasping nuance, humor, and complex instructions, and is exceptional at writing high-quality content with a natural, relatable tone. It also has strong vision capabilities.",
    "features": ["Frontier Intelligence", "2x Speed of Opus", "Cost-Effective", "Advanced Vision Capabilities", "Strong Coding Proficiency", "Improved Nuance/Humor Understanding"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Release Date", "value": "June 2024" }
    ],
    "apiProviders": ["Anthropic API", "Amazon Bedrock", "Google Cloud Vertex AI"],
    "pricing": {
      "inputPrice": "3",
      "outputPrice": "15"
    },
    "keyMetrics": [
      { "name": "MMLU", "score": "90%" },
      { "name": "MT-Bench", "score": "9.6" },
      { "name": "HumanEval", "score": "92%" },
      { "name": "GPQA Diamond", "score": "59.4%" }
    ],
    "trainingDataCutoff": "April 2024",
    "inputPrice": "3",
    "outputPrice": "15"
  },
  {
    "id": "claude-4-sonnet",
    "name": "Claude 4 Sonnet",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/news/claude-4",
    "isOpenSource": false,
    "description": "Claude 4 Sonnet is a significant upgrade from Claude Sonnet 3.7, achieving exceptional performance in coding with 72.7% on SWE-bench. It balances performance and efficiency for high-volume use cases while being 65% less likely to use shortcuts or loopholes compared to its predecessor. This model features extended thinking capabilities, parallel tool execution, and improved instruction following, making it ideal for customer-facing agents, code generation, computer use, and chatbots.",
    "features": [
      "Extended thinking with tool use (beta)",
      "Parallel tool execution", 
      "Improved instruction following",
      "Vision capabilities",
      "Constitutional AI safety",
      "Advanced memory capabilities",
      "65% less shortcut usage vs 3.7"
    ],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Max Output", "value": "64K tokens" },
      { "name": "Release Date", "value": "May 2025" }
    ],
    "apiProviders": ["Anthropic API", "Amazon Bedrock", "Google Cloud Vertex AI"],
    "modalities": ["Text", "Code", "Vision"],
    "keyMetrics": [
      { "name": "SWE-bench", "score": "72.7%" },
      { "name": "GPQA Diamond", "score": "88.5%" },
      { "name": "HumanEval", "score": "94.2%" },
      { "name": "MMLU", "score": "91.8%" }
    ],
    "inputPrice": "3.00",
    "outputPrice": "15.00"
  },
  {
    "id": "claude-4-opus",
    "name": "Claude 4 Opus",
    "provider": "Anthropic",
    "providerURL": "https://www.anthropic.com/news/claude-4",
    "isOpenSource": false,
    "description": "Claude 4 Opus is Anthropic's most powerful model and the best coding model in the world, leading on SWE-bench (72.5%) and Terminal-bench (43.2%). This hybrid reasoning model offers near-instant responses and extended thinking modes, designed for sustained performance on long-running tasks. It excels at complex problem-solving, coding, research, writing, and scientific discovery with advanced memory capabilities when given local file access.",
    "features": [
      "Best coding model in the world",
      "Hybrid reasoning model",
      "Near-instant responses",
      "Extended thinking modes",
      "Advanced memory capabilities",
      "Tool use capabilities",
      "Vision capabilities",
      "Constitutional AI safety",
      "Sustained performance on long tasks"
    ],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Max Output", "value": "4K tokens" },
      { "name": "Release Date", "value": "May 2025" }
    ],
    "apiProviders": ["Anthropic API", "Amazon Bedrock", "Google Cloud Vertex AI"],
    "modalities": ["Text", "Code", "Vision"],
    "keyMetrics": [
      { "name": "SWE-bench", "score": "72.5%" },
      { "name": "Terminal-bench", "score": "43.2%" },
      { "name": "GPQA Diamond", "score": "89.8%" },
      { "name": "HumanEval", "score": "95.1%" },
      { "name": "MMLU", "score": "92.5%" }
    ],
    "inputPrice": "15.00",
    "outputPrice": "75.00"
  },
  {
    "id": "v0-1.0-md",
    "name": "v0-1.0-md",
    "provider": "Vercel",
    "providerURL": "https://v0.dev/",
    "isOpenSource": false,
    "description": "v0-1.0-md is Vercel's specialized AI model designed for building modern web applications. It excels in frontend and full-stack development tasks with framework-aware completions, particularly optimized for Next.js and Vercel's ecosystem. The model features auto-fix capabilities for common coding issues, quick edit streaming for inline changes, and multimodal support for both text and image inputs.",
    "features": [
      "Framework-aware completions",
      "Auto-fix for common coding issues",
      "Quick edit streaming",
      "Multimodal support",
      "OpenAI API compatibility"
    ],
    "specs": [
      { "name": "Input Context", "value": "128K tokens" },
      { "name": "Max Output", "value": "32K tokens" },
      { "name": "Release Date", "value": "May 2024" }
    ],
    "apiProviders": ["Vercel API", "v0.dev"],
    "modalities": ["Text", "Code", "Vision"],
    "keyMetrics": [
      { "name": "Frontend Dev", "score": "92.5%" },
      { "name": "Code Gen", "score": "89.8%" },
      { "name": "UI/UX", "score": "94.3%" }
    ],
    "trainingDataCutoff": "May 2024",
    "inputPrice": "3",
    "outputPrice": "15"
  },
  {
    "id": "o3",
    "name": "o3",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "o3 is OpenAI's most powerful reasoning model, and it's one of the most advanced AI models currently available. Reasoning models like o3 are best for logical, technical, and scientific tasks. If you need the most powerful model OpenAI has for generating computer code, analyzing text documents and images, or solving complex puzzles, o3 is the one to use. But because reasoning models use additional resources to work through problems, they're more expensive for tasks that don't require advanced reasoning.",
    "features": ["Advanced Reasoning", "Logic", "Code Generation", "Text Analysis", "Image Analysis"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Release Date", "value": "N/A" }
    ],
    "keyMetrics": [
      { "name": "AIME 2024", "score": "90%" },
      { "name": "GPQA Diamond", "score": "81%" },
      { "name": "Codeforces", "score": "2517 Elo" },
      { "name": "ARC-AGI", "score": "75.7%" }
    ],
    "inputPrice": "2.00",
    "outputPrice": "8.00"
  },
  {
    "id": "o3-pro",
    "name": "o3-pro",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "o3-pro is the same underlying model as o3, but it's allowed to reason for more time to provide more reliable responses. While the two models are obviously very similar, OpenAI claims that o3-pro consistently outperforms o3 in head-to-head tests. o3-pro makes the most sense for researchers and engineers pushing the limits of what AI models can do. If you absolutely need the most accurate reasoning model, it makes sense to choose it over o3. Otherwise, the performance gains may not be worth the price premium.",
    "features": ["Advanced Reasoning", "Logic", "Code Generation", "Text Analysis", "Image Analysis"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Release Date", "value": "N/A" }
    ],
    "keyMetrics": [
      { "name": "AIME 2024", "score": "93%" },
      { "name": "GPQA Diamond", "score": "84%" },
      { "name": "Codeforces", "score": "2748 Elo" }
    ],
    "inputPrice": "20.00",
    "outputPrice": "80.00"
  },
  {
    "id": "o4-mini",
    "name": "o4-mini",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "o4-mini is OpenAI's most powerful small reasoning model. It was developed from the as-yet-unreleased o4 model, and as a result, it's almost as powerful as o3 at just over 1/10th the price. o4-mini is the best reasoning model for most situations. If you're truly pushing the limits of what AI can do, o3 can give slightly better results, but in many situations, o4-mini's speed, affordability, and higher usage limits offset the small drop in reasoning ability.",
    "features": ["Affordable Reasoning", "Logic", "Code Generation", "Text Analysis", "Image Analysis"],
    "specs": [
      { "name": "Input Context", "value": "200K tokens" },
      { "name": "Release Date", "value": "N/A" }
    ],
    "keyMetrics": [
      { "name": "MMLU", "score": "83.2%" },
      { "name": "AIME", "score": "92.7%" },
      { "name": "Codeforces", "score": "2719 Elo" },
      { "name": "SWE-Bench Verified", "score": "68.1%" }
    ],
    "inputPrice": "1.10",
    "outputPrice": "4.40"
  },
  {
    "id": "gpt-4.1-nano",
    "name": "GPT-4.1 nano",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "GPT-4.1 nano is the smallest GPT-4.1 model available. As a result, it's the fastest and cheapest model—though it isn't as powerful as GPT-4.1 or GPT-4.1 mini. It's the model to use for simple tasks, or when you need to prioritize speed and cost-effectiveness.",
    "features": ["Speed Optimized", "Cost-Effective", "Text Generation", "Image Generation"],
    "specs": [
      { "name": "Input Context", "value": "1,047,576 tokens" },
      { "name": "Release Date", "value": "N/A" }
    ],
    "keyMetrics": [],
    "inputPrice": "0.10",
    "outputPrice": "1.40"
  },
  {
    "id": "gpt-4o-mini",
    "name": "GPT-4o mini",
    "provider": "OpenAI",
    "providerURL": "https://openai.com/",
    "isOpenSource": false,
    "description": "Like GPT-4o, GPT-4o mini has been replaced by the more affordable and powerful GPT-4.1 mini in the API—though it still powers ChatGPT for free users. Similarly, GPT-4o mini Audio offers audio inputs and outputs for ¼th the cost of GPT-4o Audio. For developers that need an audio model but are cost constrained, it's the best option.",
    "features": ["Multimodal", "Budget-Friendly", "Text Generation", "Audio Generation", "Image Generation"],
    "specs": [
        { "name": "Input Context", "value": "128,000 tokens" },
        { "name": "Release Date", "value": "N/A" }
    ],
    "keyMetrics": [
      { "name": "MMLU Pro", "score": "62.7%" },
      { "name": "GPQA", "score": "44.2%" },
      { "name": "LegalBench", "score": "76.2%" },
      { "name": "MedQA", "score": "72.4%" }
    ],
    "inputPrice": "0.15",
    "outputPrice": "0.60"
  }
];

// Fix the ID format for Llama 3 18B
const llamaIndex = llmModels.findIndex(model => model.id === "llama-3-18b");
if (llamaIndex !== -1) {
  llmModels[llamaIndex].id = "llama-3.18b";
}

// Provider normalization mapping
export const providerMap = {
  'Alibaba': ['Alibaba', 'Alibaba Cloud', 'Qwen'],
  'OpenAI': ['OpenAI', 'GPT'],
  'DeepSeek': ['DeepSeek', 'DeepSeek AI'],
  'Snowflake': ['Snowflake'],
  'Google': ['Google', 'Gemini'],
  'Anthropic': ['Anthropic', 'Claude'],
  'Meta': ['Meta', 'Llama'],
  'xAI': ['xAI', 'Grok'],
  'Mistral AI': ['Mistral', 'Mistral AI'],
  'Microsoft': ['Microsoft', 'Phi'],
  '01.AI': ['01.AI', 'Yi'],
  'AI21 Labs': ['AI21', 'AI21 Labs', 'Jurassic'],
  'Cohere': ['Cohere', 'Command'],
  'Databricks': ['Databricks', 'DBRX'],
  'Aleph Alpha': ['Aleph Alpha', 'Luminous'],
  'Upstage': ['Upstage', 'Solar']
};

// Normalize provider names
export const normalizeProvider = (provider) => {
  for (const [normalizedName, variants] of Object.entries(providerMap)) {
    if (variants.some(v => provider.includes(v))) {
      return normalizedName;
    }
  }
  return provider;
};

// Get unique providers after normalization
export const allProvidersFromModels = [...new Set(llmModels.map(model => normalizeProvider(model.provider)))];

// Initial provider filters
export const initialProviderFilters = allProvidersFromModels.reduce((acc, provider) => {
  acc[provider] = false; // Set all providers to false by default
  return acc;
}, {}); 